import script from "./HelpContent.vue?vue&type=script&setup=true&lang=js"
export * from "./HelpContent.vue?vue&type=script&setup=true&lang=js"

import "./HelpContent.vue?vue&type=style&index=0&id=4a07ebca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a07ebca"]])

export default __exports__